import styled from '@emotion/styled'
import type { SpanProps } from 'commons/types/htmlElements'
import { theme } from 'styles/theme/hav-theme'

export type TextAlignType =
  | 'left'
  | 'right'
  | 'center'
  | 'justify'
  | 'justify-all'
  | 'start'
  | 'end'
  | 'match-parent'

export type PositionType = 'relative' | 'absolute'

export const RowColumnStyled = styled('div')`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;

  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    flex-direction: column;
    align-items: center;
  }
`
interface TitleStyledProps extends SpanProps {
  supportColor: 'success' | 'warning' | 'error' | 'red'
}

export const TitleStyled = styled('span')<TitleStyledProps>`
  font-size: ${theme.typography.sizes['2md']};
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.lg};
  line-height: normal;
  height: 'auto';
  margin: auto 0;
  color: ${({ supportColor }) =>
    supportColor === 'success'
      ? theme.colors.support.success
      : supportColor === 'warning'
        ? theme.colors.support.warning
        : supportColor === 'red'
          ? theme.colors.secondary
          : theme.colors.alert.danger.main};
  align-self: flex-start;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media only screen and (max-width: ${theme.breakpoints.xl}px) {
    max-width: 280px;
  }

  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    width: 200px;
  }
  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    margin-bottom: ${theme.spacing.sm};
    font-size: ${theme.typography.sizes.xm};
  }
`

interface SubTitleStyleProps extends SpanProps {
  width: 'auto' | 'inherit'
}

export const SubTitleStyled = styled('div')<SubTitleStyleProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: ${({ width }) => width};
  font-size: ${theme.typography.sizes.lg};
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.lg};
  margin-left: ${theme.spacing.xm};

  & #AccordionSubtitle {
    white-space: normal;
    text-align: left;
  }

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    margin-left: ${theme.spacing.lg};
  }

  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    margin-left: 0px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${theme.spacing.sm} ${theme.spacing.md};
  }

  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    margin-left: 0;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${theme.spacing.sm};
    column-gap: ${theme.spacing.md};
  }
`

interface ColumnStyledProps extends SpanProps {
  textAlign: TextAlignType
  positionContent?: PositionType
}

export const ColumnStyled = styled('span')<ColumnStyledProps>`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  margin-bottom: auto;
  font-family: ${theme.typography.family.primary};
  font-size: ${theme.typography.sizes['2md']};
  font-weight: ${theme.typography.weight.lg};
  margin-right: ${theme.spacing['2xl']};
  text-align: ${({ textAlign }) => textAlign};
  position: relative;

  :last-of-type {
    margin-right: ${theme.spacing.xm};
  }

  svg.MuiSvgIcon-root {
    font-size: 30px !important;
    margin: ${theme.spacing.xs} 0 0 ${theme.spacing.xs};
  }

  span {
    white-space: nowrap;
  }

  @media only screen and (max-width: ${theme.breakpoints.xl}px) {
    margin-right: ${theme.spacing.lg};
    :last-of-type {
      margin-right: ${theme.spacing.md};
    }
  }

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    margin-right: ${theme.spacing.xm};
  }

  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    margin-right: 0;
    :last-of-type {
      margin-right: 0;
    }

    text-align: left;

    & [positionContent],
    &.iconSpan {
      position: relative;
      top: 0;
      right: -26px;

      div {
        display: block;

        svg.MuiSvgIcon-root {
          margin: 0;
        }
      }
    }
  }
`

export const RowStyled = styled('div')`
  display: flex;
  flex-direction: row;
  margin-right: 0;
`
